var s = Object.defineProperty;
var r = Object.getOwnPropertySymbols;
var h = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
var n = (e, t, l) => t in e ? s(e, t, { enumerable: !0, configurable: !0, writable: !0, value: l }) : e[t] = l, m = (e, t) => {
  for (var l in t || (t = {}))
    h.call(t, l) && n(e, l, t[l]);
  if (r)
    for (var l of r(t))
      i.call(t, l) && n(e, l, t[l]);
  return e;
};
var o = (e, t) => {
  var l = {};
  for (var C in e)
    h.call(e, C) && t.indexOf(C) < 0 && (l[C] = e[C]);
  if (e != null && r)
    for (var C of r(e))
      t.indexOf(C) < 0 && i.call(e, C) && (l[C] = e[C]);
  return l;
};
import * as a from "react";
const p = (C) => {
  var c = C, {
    title: e,
    titleId: t
  } = c, l = o(c, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ a.createElement("svg", m({ width: 32, height: 32, viewBox: "0 0 13 14", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t }, l), e ? /* @__PURE__ */ a.createElement("title", { id: t }, e) : null, /* @__PURE__ */ a.createElement("g", { clipPath: "url(#clip0_3024_2717)" }, /* @__PURE__ */ a.createElement("path", { d: "M4.98635 10.0887L2.36135 7.46372C2.30008 7.40296 2.25143 7.33112 2.21824 7.25147C2.18506 7.17181 2.16797 7.08551 2.16797 6.99922C2.16797 6.91293 2.18506 6.82765 2.21824 6.748C2.25143 6.66834 2.30008 6.59651 2.36135 6.53574C2.42168 6.47409 2.49382 6.4253 2.57348 6.39219C2.65313 6.35908 2.73866 6.34224 2.82492 6.34297C2.91109 6.34286 2.99641 6.36014 3.07598 6.39321C3.15555 6.42629 3.22779 6.47459 3.2885 6.53574L5.44887 8.69624L10.2337 3.90869C10.2947 3.84725 10.3672 3.79851 10.4471 3.76514C10.5269 3.73177 10.6126 3.71406 10.6992 3.71387C10.7858 3.71368 10.8715 3.7311 10.9515 3.76411C11.0316 3.79713 11.1043 3.84547 11.1655 3.90664C11.2268 3.96782 11.2753 4.03994 11.3084 4.11992C11.3415 4.19991 11.3585 4.2856 11.3584 4.37217C11.3584 4.45874 11.3412 4.5445 11.3079 4.62442C11.2746 4.70433 11.2259 4.77767 11.1645 4.83872L5.91452 10.0887C5.85374 10.1498 5.7815 10.1982 5.70195 10.2313C5.62239 10.2643 5.5371 10.2805 5.45095 10.2805C5.3648 10.2805 5.27951 10.2643 5.19995 10.2313C5.1204 10.1982 5.04816 10.1498 4.98738 10.0887H4.98635Z" })), /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", null, /* @__PURE__ */ a.createElement("rect", { width: 12.6, height: 12.6, transform: "translate(0.199951 0.700195)" }))));
};
export {
  p as default
};
